const DEFAULT = {
  duration: 5 * 1000, // 5 sec
};

// semantic variant configs
const ERROR = {
  ...DEFAULT,
  panelClass: ['is-danger'],
};
const INFO = {
  ...DEFAULT,
  panelClass: ['is-info'],
};
const SUCCESS = {
  ...DEFAULT,
  panelClass: ['is-success'],
};
const WARNING = {
  ...DEFAULT,
  panelClass: ['is-warning'],
};

export const SnackBarConfig = {
  DEFAULT,
  ERROR,
  INFO,
  SUCCESS,
  WARNING,
} as const;
